import React from "react"

import { AnchorProps } from "shared/ui/link/Anchor"

import { ProjectsOverviewCard } from "./ProjectsOverviewCard"
import { useProjectsOverviewCardModel } from "./model/useProjectsOverviewCardModel"
import { ProjectsOverviewCardLoader } from "./ui/ProjectsOverviewCardLoader"

export interface ProjectsOverviewCardConnectorProps extends AnchorProps {
  projectID?: string | null
  isLoading?: boolean
}

export const ProjectsOverviewCardConnector = React.memo(
  React.forwardRef(
    (
      props: ProjectsOverviewCardConnectorProps,
      ref?: React.ForwardedRef<HTMLAnchorElement>
    ) => {
      const { projectID, isLoading } = props

      if (isLoading || !projectID) {
        return <ProjectsOverviewCardLoader />
      }

      return (
        <ProjectsOverviewCardConnectorInner
          ref={ref}
          {...props}
          projectID={projectID}
        />
      )
    }
  )
)

interface ProjectsOverviewCardConnectorInnerProps extends AnchorProps {
  projectID: string
}

const ProjectsOverviewCardConnectorInner = React.memo(
  React.forwardRef(
    (
      props: ProjectsOverviewCardConnectorInnerProps,
      ref?: React.ForwardedRef<HTMLAnchorElement>
    ) => {
      const { projectID } = props
      const model = useProjectsOverviewCardModel({ projectID })

      return (
        <ProjectsOverviewCard
          {...props}
          model={model}
          projectID={projectID}
          ref={ref}
        />
      )
    }
  )
)
